export const rootCss = (
  hasCurrentAssignment: boolean,
  isUpdateMode: boolean,
  isMobile?: boolean,
) => {
  const isHidden = isMobile && isUpdateMode;

  return {
    ...(isHidden
      ? {
          display: "none",
        }
      : {}),
    ...(hasCurrentAssignment
      ? {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }
      : {}),
    ...(isMobile
      ? {
          height: "32px",
        }
      : {}),
  };
};

export const mobileSaveCss = {
  width: "100%",
};
